import { render } from "./AuthenticationCallback.vue?vue&type=template&id=1000fbe2&ts=true"
import script from "./AuthenticationCallback.vue?vue&type=script&lang=ts"
export * from "./AuthenticationCallback.vue?vue&type=script&lang=ts"

import "./AuthenticationCallback.vue?vue&type=style&index=0&id=1000fbe2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__